// extracted by mini-css-extract-plugin
export default {"section":"ApplyNow_section__r-MNC","button_div":"ApplyNow_button_div__-e3tu"};